module.exports = __webpack_public_path__ + "img/logo_bc.0c6a230f.png";